import { Injectable } from '@angular/core';
import { ClaimService } from '../../services/claim.service';

@Injectable()
export class AddClaimService extends ClaimService {}